export default "__VITE_ASSET__BiUGP4$p__"